import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

// Helper function to debounce API calls
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

class InternalCompanyIdentifier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            internalId: props.internalid || '',
            loading: false,
            success: null,
            error: null,
            peopleId: props.peopleid || '',
            personaInvitedId: props.personainvitedid || '',
            label: props.label || 'Número identificador interno',
            canEdit: props.canedit === true || props.canedit === 'true' || props.canedit === '1',
            lastSavedValue: props.internalid || ''
        };
        
        // Bind the debounced function
        this.debouncedUpdate = debounce(this.handleSubmit, 1000);
    }

    handleSubmit = (e) => {
        // Prevent default only if it's an event (from form submission)
        if (e && e.preventDefault) e.preventDefault();
        
        // Don't submit if the value hasn't changed
        if (this.state.internalId === this.state.lastSavedValue) return;
        if (!this.state.canEdit) return;
        
        this.setState({ loading: true, success: null, error: null });

        const formData = new FormData();
        formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
        formData.append('internal_id', this.state.internalId);
        formData.append('people_id', this.state.peopleId);
        formData.append('persona_invited_id', this.state.personaInvitedId);

        axios.post('/api/internal_company_identifier', formData)
            .then(response => {
                this.setState({ 
                    loading: false, 
                    success: response.data.message || 'Número identificador interno actualizado correctamente',
                    error: null,
                    lastSavedValue: this.state.internalId
                });
                
                // Clear success message after 3 seconds
                setTimeout(() => {
                    this.setState({ success: null });
                }, 3000);
            })
            .catch(error => {
                this.setState({ 
                    loading: false, 
                    error: error.response?.data?.message || 'Error al actualizar el identificador',
                    success: null 
                });
            });
    }

    handleChange = (e) => {
        const newValue = e.target.value;
        this.setState({ internalId: newValue }, () => {
            // Call the debounced update function
            this.debouncedUpdate(e);
        });
    }

    render() {
        const { internalId, loading, success, error } = this.state;
        const disabled = loading || !this.state.canEdit;
        
        return (
            <div className="mb-4">
                <p className="text-muted text-left font-weight-bold">
                    {this.state.label} 
                </p>
                
                {success && (
                    <div className="alert alert-success mb-3 py-2 small">
                        {success}
                    </div>
                )}
                
                {error && (
                    <div className="alert alert-danger mb-3 py-2 small">
                        {error}
                    </div>
                )}
                
                <div className="form-group">
                    <input 
                        type="text" 
                        className="form-control" 
                        value={internalId}
                        onChange={this.handleChange}
                        onBlur={this.handleSubmit}
                        disabled={disabled}
                        required
                        placeholder="Escribe para actualizar..."
                    />
                    {loading && (
                        <small className="text-muted">
                            <i className="fas fa-spinner fa-spin"></i> Guardando...
                        </small>
                    )}
                </div>
            </div>
        );
    }
}

export default InternalCompanyIdentifier;

if (document.getElementById('InternalCompanyIdentifier')) {
    const element = document.getElementById('InternalCompanyIdentifier');
    const props = {
        initialValue: element.dataset.initialValue || '',
        peopleId: element.dataset.peopleId,
        personaInvitedId: element.dataset.personaInvitedId,
        label: element.dataset.label,
        canEdit: element.dataset.canEdit
    };
    
    ReactDOM.render(
        <InternalCompanyIdentifier {...props} />,
        element
    );
}
